import React, { useState } from 'react';

const AdModal = ({ show, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null,
    contact: ''
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
    setFormData({ title: '', description: '', image: null, contact: '' });
  };

  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">जाहिरात जोडा</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">शीर्षक</label>
              <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">जाहिरातीचे वर्णन</label>
              <textarea className="form-control" name="description" rows="3" value={formData.description} onChange={handleChange}></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">छायाचित्र</label>
              <input type="file" className="form-control" name="image" accept="image/*" onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">संपर्क क्रमांक</label>
              <input type="text" className="form-control" name="contact" value={formData.contact} onChange={handleChange} />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-success" onClick={handleSubmit}>सबमिट करा</button>
            <button className="btn btn-secondary" onClick={onClose}>रद्द करा</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdModal;
